import * as React from 'react'
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom'

import { ContactData } from './ContactData'
import { Deductible } from './Deductible'
import { LocationScope } from './LocationScope'
import { PreviousInsurances } from './PreviousInsurances'
import { TypeOfGoods } from './TypeOfGoods'
import { Vehicles } from './Vehicles'

export class CalculatorLayout extends React.Component<
  RouteComponentProps<any>
> {
  render() {
    const { match } = this.props
    return (
      <>
        <Switch>
          <Route path={`${match.path}/vehicles`} component={Vehicles} />
          <Route path={`${match.path}/deductible`} component={Deductible} />
          <Route
            path={`${match.path}/location-scope`}
            component={LocationScope}
          />
          <Route
            path={`${match.path}/transporting-goods`}
            component={TypeOfGoods}
          />
          <Route
            path={`${match.path}/previous-insurance`}
            component={PreviousInsurances}
          />
          <Route path={`${match.path}/contact-data`} component={ContactData} />
        </Switch>
      </>
    )
  }
}

export const Calculator = withRouter(CalculatorLayout)
